"use strict";

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.sanitizeActionTypes = sanitizeActionTypes;
exports.getSelectedOptionSingle = getSelectedOptionSingle;
exports.getSelectedOptionsMulti = getSelectedOptionsMulti;
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _useListBox = _interopRequireDefault(require("../useListBox"));

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function sanitizeActionTypes() {
  var actionTypes = _useListBox["default"].types;
  return {
    clear: actionTypes.clear,
    closePopover: actionTypes.closePopover,
    openPopover: actionTypes.openPopover,
    reset: actionTypes.reset,
    selectSingleOption: actionTypes.selectSingleOption,
    togglePopover: actionTypes.togglePopover,
    unhideOptions: actionTypes.unhideOptions,
    unselectOptions: actionTypes.unselectOptions
  };
}

function getSelectedOptionSingle(state) {
  var activeOptionIndex = state.selectedOptions && state.selectedOptions.length === 0 ? null : state.selectedOptions[0];
  return [activeOptionIndex, state.options];
}

function getSelectedOptionsMulti(state) {
  return [state.selectedOptions, state.options, state.activeOption];
}

var invokeOnChange = function invokeOnChange() {
  var onChangeCallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  var eventType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var event = arguments.length > 2 ? arguments[2] : undefined;
  return function (state, dispatch) {
    if (!onChangeCallback) {
      // This could mean that the consumer might decide to use onClickAccept in the footer without a onChange or
      // added a footer without onClickAccept.
      return;
    }

    if (state.isMulti) {
      var _getSelectedOptionsMu = getSelectedOptionsMulti(state),
          _getSelectedOptionsMu2 = (0, _slicedToArray2["default"])(_getSelectedOptionsMu, 3),
          _selected = _getSelectedOptionsMu2[0],
          _options = _getSelectedOptionsMu2[1],
          current = _getSelectedOptionsMu2[2];

      onChangeCallback(_selected, _options, current, _objectSpread({
        dispatch: dispatch,
        actionTypes: sanitizeActionTypes(),
        eventType: eventType
      }, event));
      dispatch({
        type: _useListBox["default"].types.cleanOnChangeFn
      });
      return;
    }

    var _getSelectedOptionSin = getSelectedOptionSingle(state),
        _getSelectedOptionSin2 = (0, _slicedToArray2["default"])(_getSelectedOptionSin, 2),
        selected = _getSelectedOptionSin2[0],
        options = _getSelectedOptionSin2[1];

    onChangeCallback(selected, options, _objectSpread({
      dispatch: dispatch,
      actionTypes: sanitizeActionTypes(),
      eventType: eventType
    }, event));
    dispatch({
      type: _useListBox["default"].types.cleanOnChangeFn
    });
  };
};

var _default = invokeOnChange;
exports["default"] = _default;
//# sourceMappingURL=invokeOnChange.js.map